module.exports = __webpack_public_path__ + "assets/img/astateRun.a3e070a3.png";